export default function R_Quiz() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Quiz Component</h1>
      <p>This is the R_Quiz tutorial section.</p>
    </div>
  );
}
